module.exports = __webpack_public_path__ + "static/media/aam-general.3200c018.jpg";